import React, { useState, useEffect, } from "react";
import { useDispatch } from "react-redux";
import axios from "axios";
import Layout from "../../components/layout";
import { showLoading, hideLoading } from "../../redux/alertsSlice";
import { Card, Form, Input, Button, DatePicker, Select, Radio } from "antd";
import moment from "moment";
import toast from "react-hot-toast";

const { Option } = Select;


function CompleteAppointment() {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [appointments, setAppointments] = useState([]);
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  const [followUpNeeded, setFollowUpNeeded] = useState(false);
 

  useEffect(() => {
    const fetchAppointments = async () => {
      try {
        dispatch(showLoading());
        const response = await axios.get("/api/doctor/get-appointments-by-doctor-id", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        dispatch(hideLoading());
        // Filter out completed appointments
      const filteredAppointments = response.data.data.filter(appointment => appointment.status !== "completed" && appointment.status !== "rejected");
      setAppointments(filteredAppointments);
    
      } catch (error) {
        toast.error("Failed to fetch appointments");
        dispatch(hideLoading());
        console.error("Failed to fetch appointments:", error); // Debug log
      }
    };

    fetchAppointments();
  }, [dispatch]);


  


  const completeAppointment = async (values) => {
    try {
      dispatch(showLoading());
      const response = await axios.post(
        "/api/doctor/complete-appointment",
        { ...values, appointmentId: selectedAppointment._id },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      dispatch(hideLoading());
      if (response.data.success) {
        toast.success(response.data.message);
        form.resetFields();
        setSelectedAppointment(null);
      }
    } catch (error) {
      toast.error("Something went wrong");
      dispatch(hideLoading());
      console.error("Error completing appointment:", error); // Debug log
    }
  };


  const handleFollowUpChange = (e) => {
    setFollowUpNeeded(e.target.value === "yes");
    if (e.target.value === "no") {
      form.setFieldsValue({ followUpDate: null });
    }
  }; 


// Inside your component's return
return (
  <Layout>

    <Card title="Complete Appointment Form" bordered={false} className="mb-4" style={{ maxWidth: 800, margin: "0 auto" }}>
      <Form form={form} layout="vertical" onFinish={completeAppointment}>
        <Form.Item
          name="appointment"
          label="Select Appointment"
          rules={[{ required: true, message: "Please select an appointment" }]}
        >
          <Select
            placeholder="Select an appointment"
            onChange={(value) => {
              const appointment = appointments.find(app => app._id === value);
              setSelectedAppointment(appointment);
            }}
          >
            {appointments.map(appointment => (
              <Option key={appointment._id} value={appointment._id}>
                Patient Name - {appointment.userInfo.name} | Appointment Service - {appointment.doctorInfo.service} | Appointment Date - {moment(appointment.date).format("DD/MM/YYYY")} | Status - {appointment.status}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name="comment"
          label="Comment"
          rules={[{ required: true, message: "Please add a comment note" }]}
        >
          <Input.TextArea rows={4} placeholder="Add comment..." />
        </Form.Item>

        <Form.Item
          name="followUpNeeded"
          label="Is Follow-Up Needed?"
          rules={[{ required: true, message: "Please select an option" }]}
        >
          <Radio.Group onChange={handleFollowUpChange}>
            <Radio value="yes">Yes</Radio>
            <Radio value="no">No</Radio>
          </Radio.Group>
        </Form.Item>

        {followUpNeeded && (
          <Form.Item
            name="followUpDate"
            label="Follow-Up Date"
            rules={[{ required: true, message: "Please select a follow-up date" }]}
          >
            <DatePicker placeholder="Select follow-up date" style={{ width: "100%" }} />
          </Form.Item>
        )}

        <Form.Item>
          <Button type="primary" htmlType="submit">
            Complete Appointment
          </Button>
        </Form.Item>
      </Form>
    </Card>
  </Layout>
);
}

export default CompleteAppointment;
